import { HashMap } from '../../constants';
import { Loadable } from '../../models';
import { PageParameters } from '../../models/account';

/** The number of seconds the application will wait before refreshing the user command types from the server. */
export const UserCommandTypesCacheTimeout = 3600;

/**
 * Interface which encapsulates the user's available command types.
 */
export interface UserCommandTypes extends PageParameters {
  all: string[];
}

export const getDefaultUserCommandTypesState = (): Loadable<UserCommandTypes> => {
  return {
    companyId: 0,
    isLoading: false,
    all: [],
  };
};
